

define(['jquery', 'angular', 'squid/index'], function ($, angular, squid) {
    squid.module('xo-validation.directive', ['squid']).directive('xoValidation', function () {
        return {
            template: '',
            restrict: 'A',
            require: 'ngModel',

            link: function link(scope, elem, attr, ngModel) {

                var validationUtil = {

                    // because IE8 doesnt have String.prototype.trim()
                    trim: function trim(value) {
                        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
                        return value.replace(rtrim, '');
                    },

                    /**
                     * Generic function that runs a given input against
                     * a given regular expression
                     *
                     * @param {String} value input to test
                     * @param {String/RegExp} regex Regular expression to test against
                     * @returns {Boolean} matches or does not match given pattern
                     */
                    valid: function valid(value, regex) {
                        if (this.empty(value)) {
                            return false;
                        }

                        if (angular.isString(regex)) {
                            regex = new RegExp(regex);
                        }

                        return regex ? regex.test(value) : true;
                    },

                    // returns whether empty or not
                    empty: function empty(value) {
                        if (!value) {
                            return true;
                        }

                        // IE8 and below doesn't have native .trim()
                        return !this.trim(value);
                    },

                    // returns whether alphabetic or not
                    alphabetic: function alphabetic(value) {
                        return this.valid(value, /[A-Za-z]+$/);
                    },

                    // returns whether numeric or not
                    numeric: function numeric(value) {
                        var NUMERIC_REGEX = new RegExp('^[0-9]+$');

                        return this.valid(value, NUMERIC_REGEX);
                    },

                    validBankAccount: function validBankAccount(value) {
                        if (!scope.showIBAN) {
                            return this.numeric(value);
                        }

                        return true;
                    },

                    validRouting: function validRouting(value) {
                        if (!scope.showIBAN) {
                            return this.valid(value, /^\d{8}$/);
                        }
                        return true;
                    },

                    validIBANCode: function validIBANCode(value) {
                        if (scope.showIBAN) {
                            value = value && value.replace(/ +/g, '');
                            return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
                        }
                        return true;
                    },

                    validIBAN: function validIBAN(value) {
                        if (scope.showIBAN) {
                            value = value && value.replace(/ +/g, '');
                            return this.valid(value, /^DE\d{20}$/);
                        }
                        return true;
                    },

                    validIBANCountry: function validIBANCountry(value) {
                        value = value && value.replace(/ +/g, '');
                        return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
                    },

                    // first two letters are the country code the rest are the bank account numbers max length 32
                    validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
                        value = value && value.replace(/ +/g, '');
                        return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
                    },

                    validLast4: function validLast4(value) {
                        // @TODO - Unsafe regular expression, need to fix.
                        var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex
                        return this.valid(value, LAST_4);
                    },

                    validStreet: function validStreet(value) {
                        return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
                    },

                    // Validating phone format with metadata from griffin
                    validPhone: function validPhone(value) {
                        var regex = scope.pattern;
                        /*
                         * User can enter phone format in various manner according to griffin mask
                         * (00) 0000-0000
                         * 00 000 0000
                         * Since the griffin pattern only validates against numbers, need to trim the input
                         * to only validate the numbers
                         */
                        value = value && value.replace(/[^0-9]/gi, '');
                        return this.valid(value, regex);
                    },

                    validDobYear: function validDobYear(value) {
                        return value !== 'YYYY';
                    },

                    validDobDay: function validDobDay(value) {
                        return value !== 'DD';
                    },

                    validDobMonth: function validDobMonth(value) {
                        return value !== 'MM';
                    },

                    validPoBox: function validPoBox(value) {
                        // @TODO - Unsafe regular expression, need to fix.
                        var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex

                        if (boxRE.test(value)) {
                            return true;
                        }
                        return false;
                    },

                    validAddressSansPoBox: function validAddressSansPoBox(value) {
                        var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
                        var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;

                        if (boxRE.test(value) || cassRE.test(value)) {
                            return false;
                        }
                        return true;
                    },

                    validEmailOrPhone: function validEmailOrPhone(value) {
                        if (!value) {
                            return false;
                        }

                        return this.validEmail(value) || this.validPhone(value);
                    },

                    validEmail: function validEmail(value) {
                        if (!value) {
                            return false;
                        }
                        var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
                        // @TODO - Unsafe regular expression, need to fix.
                        var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line

                        return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
                    },

                    highAscii: function highAscii(value) {
                        var trimmedValue = this.trim(value);
                        // @TODO - Unsafe regular expression, need to fix.
                        var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex

                        return this.valid(trimmedValue, HIGH_ASCII_REGEX);
                    },

                    // expected format: MM/DD/YYYY
                    validDate: function validDate(value) {
                        var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                        var dArr = value.split('/');
                        var d = new Date(value);
                        var isValid = false;

                        if (re.test(value)) {
                            isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
                        }

                        return isValid;
                    },

                    /* Expects value and state. state can be "past" or "future".
                     NOTE: This function validates only month and year, not day!
                     Please use validDate() if you need to validate the whole date. */
                    validDateWithoutDay: function validDateWithoutDay(value, options) {
                        var state = options.state;

                        value = value.replace(/\s/g, '');

                        if (value === '') {
                            return true;
                        }

                        var split = value.split('/');
                        var month = split[0];
                        var year = split[1];
                        var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
                        var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
                        var validYear = true;
                        var validMonth = true;

                        if (value.length < 5) {
                            return false;
                        }

                        if (this.validDobMonth(month)) {
                            month = parseInt(month, 10);
                        } else {
                            return false;
                        }

                        year = parseInt(year, 10);

                        if (state === 'past') {
                            validYear = year <= currentYear;
                            if (!validYear) {
                                return false;
                            }
                            if (year === currentYear) {
                                validMonth = month <= currentMonth;
                            }
                        } else if (state === 'future') {
                            validYear = year >= currentYear;
                            if (!validYear) {
                                return false;
                            }
                            if (year === currentYear) {
                                validMonth = month >= currentMonth;
                            }
                        }

                        if (!validYear || !validMonth) {
                            return false;
                        }

                        return true;
                    },

                    // formats to MM/DD/YYYY
                    mmddyyyy: function mmddyyyy(day, month, year) {
                        if (year.length < 4) {
                            year = '20' + year;
                        }

                        return this.twoDigits(month) + '/' + this.twoDigits(day) + '/' + this.twoDigits(year);
                    },

                    // formats to YY-MMM-DDDD
                    yyyymmdd: function yyyymmdd(day, month, year) {
                        if (year.length < 4) {
                            year = '20' + year;
                        }

                        return year + '-' + this.twoDigits(month) + '-' + this.twoDigits(day);
                    },

                    // pads a number to two digits
                    twoDigits: function twoDigits(value) {
                        return value < 10 ? '0' + value : '' + value;
                    },

                    // expects YYYY-MM-DD
                    legalAge: function legalAge(value) {
                        if (this.empty(value)) {
                            return false;
                        }

                        var dateParts = value.split('-'); // expecting YYYY-MM-DD
                        var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
                        var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
                        var validBD = new Date(new Date() - 18 * yr);

                        return validBD >= birthDate;
                    },

                    validZip: function validZip(value, options) {

                        var postalCodeRegex = {
                            // TODO: Once this is removed from the xo-add-address template, we can remove it...
                            'GB': /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
                            /*
                             * Note: These are "nice to have".
                             * Once we add support for these countries, we can remove these.
                             */
                            'BA': /^\d{5}$/,
                            'CY': /^\d{4}$/,
                            'EE': /^\d{5}$/,
                            'HR': /^\d{5}$/,
                            'LU': /^\d{4}$/,
                            'LV': /^\d{4}$/,
                            'MT': /^\d{3,4}$/,
                            'SI': /^\d{4}$/,
                            'SK': /^[0-9]{3}[\s][0-9]{2}$/,
                            'NZ': /^\d{4}$/,
                            'LT': /^\d{5}$/,
                            'BG': /^\d{4}$/,
                            'CZ': /^\d{5}$/,
                            'GR': /^\d{3}[\s]\d{2}$/,
                            'HU': /^\d{4}$/,
                            'MX': /^\d{5}$/
                        };

                        var country = options && options.country;
                        var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
                        var isRequired = scope.zipEntry && scope.zipEntry.required;

                        if (!isRequired && this.empty(value)) {
                            return true;
                        }

                        // If there is no regex, or it's not populated yet...
                        if (!regex || angular.isString(regex) && regex.indexOf('validationPattern') > -1) {
                            return !this.empty(value);
                        }

                        value = value && value.toUpperCase();

                        return this.valid(value, regex);
                    },

                    validExpiry: function validExpiry(value, options) {
                        var $monthEl = $('[ng-model="card.expiry_month"]');
                        var $yearEl = $('[ng-model="card.expiry_year"]');
                        var month = $monthEl.val();
                        var year = $yearEl.val();
                        var isValid = false;
                        var monthElName = 'card.expiry_month';
                        var yearElName = 'card.expiry_year';
                        var cardType = options.cardType;

                        if (month) {
                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                        }

                        if (year) {
                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                        }

                        if (month && year) {
                            isValid = this.validExpires(month, year);
                        }

                        var formName = $monthEl.closest('form').attr('id');
                        var form = scope[formName] || scope.$parent[formName];
                        var monthFieldName = monthElName;
                        var yearFieldName = yearElName;

                        if (monthFieldName.indexOf('.') !== -1) {
                            monthFieldName = monthFieldName.split('.')[1];
                        }

                        if (yearFieldName.indexOf('.') !== -1) {
                            yearFieldName = yearFieldName.split('.')[1];
                        }

                        var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];

                        if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
                            isValid = true;
                        }

                        if (form) {
                            form[monthFieldName].$setValidity('validExpiry', isValid);
                            form[yearFieldName].$setValidity('validExpiry', isValid);
                        }

                        return isValid;
                    },

                    validExpires: function validExpires(month, year) {
                        var date = new Date();
                        var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
                        var currentMonth;

                        if (year < currentYear) {
                            return false;
                        } else if (year > currentYear) {
                            return this.validDobMonth(month);
                        }

                        // account for display date vs. system date
                        currentMonth = date.getMonth() + 1;
                        return this.validDobMonth(month) && month >= currentMonth;
                    },

                    startDate: function startDate(value, options) {
                        var valueOptions = {
                            cardType: scope.card.type
                        };
                        valueOptions[elem.attr('id')] = value;

                        return this.setStartDateValidity(valueOptions);
                    },

                    setExpiryValidity: function setExpiryValidity(options) {
                        if (!options) {
                            return true;
                        }

                        var cardType = options.cardType || '',
                            expiryValidity = this.validExpiry(null, {
                            cardType: cardType
                        });

                        return expiryValidity;
                    },

                    // start date validation for Maestro card
                    setStartDateValidity: function setStartDateValidity(options) {
                        if (!options) {
                            return true;
                        }

                        var cardType = options.cardType || '';
                        var startDateValidity = true;
                        var $monthEl = $('#startmonth');
                        var $yearEl = $('#startyear');
                        var month = $monthEl.val();
                        var year = $yearEl.val();

                        if (cardType === 'MAESTRO') {
                            if (!month || !year) {
                                startDateValidity = false;
                            }
                        }

                        var formName = $monthEl.closest('form').attr('id'),
                            form = scope[formName] || scope.$parent[formName];

                        if (form) {
                            form.startmonth.$setValidity('startDate', startDateValidity);
                            form.startyear.$setValidity('startDate', startDateValidity);
                        }

                        return startDateValidity;
                    },

                    dobField: function dobField(value, options) {
                        var valueOptions = {};
                        var fieldMap = {
                            'dobDayCC': 'day',
                            'dobMonthCC': 'month',
                            'dobYearCC': 'year'
                        };

                        valueOptions.cardType = scope.card.type;
                        valueOptions[fieldMap[elem.attr('id')]] = value;

                        return this.setDOBValidity(valueOptions);
                    },

                    setDOBValidity: function setDOBValidity(options) {
                        if (!options) {
                            return true;
                        }

                        var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];

                        var dobValidity = true;

                        var $monthEl = $('#dobMonthCC');
                        var $dayEl = $('#dobDayCC');
                        var $yearEl = $('#dobYearCC');

                        var month = options.month || $monthEl.val();
                        var year = options.year || $yearEl.val();
                        var day = options.day || $dayEl.val();

                        if (month) {
                            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
                        }

                        if (day) {
                            day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
                        }

                        if (year) {
                            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
                        }

                        var cardType = options.cardType;
                        if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
                            if (!month || !year || !day) {
                                dobValidity = false;
                                // invalidate if < 18 y/o.
                            } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
                                dobValidity = false;
                            } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
                                dobValidity = false;
                            }
                        }

                        var formName = $monthEl.closest('form').attr('id');
                        var form = scope[formName] || scope.$parent[formName];

                        if (form) {
                            form.dobMonthCC.$setValidity('dobField', dobValidity);
                            form.dobDayCC.$setValidity('dobField', dobValidity);
                            form.dobYearCC.$setValidity('dobField', dobValidity);
                        }

                        return dobValidity;
                    },

                    validName: function validName(value) {
                        return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
                        // ' this comment is to un-confuse editors on synax coloring because of the single quote above
                    },

                    isChecked: function isChecked(value, options) {
                        // $.is does not exist in $
                        // eslint-disable-line angular/ng_angularelement
                        var $el = $(options.el);

                        return $el.is(':checked');
                    },

                    validRUPassport: function validRUPassport(value, options) {
                        if (scope.user.countryOfResidence === 'RU') {
                            return this.valid(value, /^\d{10}$/);
                        }
                        return true;
                    }
                };

                var customValidator = function customValidator(value) {
                    var ruleJson = angular.fromJson(elem.attr('xo-validation'));
                    var validator = ruleJson.validator;
                    var options = ruleJson.options;

                    ngModel.$setValidity(validator, validationUtil[validator](value, options));

                    return value;
                };

                ngModel.$parsers.unshift(customValidator);
                ngModel.$formatters.unshift(customValidator);
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-validation/dist/directive.js
// module id = ./components/xo-validation/dist/directive.js
// module chunks = 1